<template>
  <td>
    {{ SeperatedNumber }}
  </td>
</template>

<script>
export default {
  props: ["model", "attribute"],
  computed: {
    SeperatedNumber() {
      return Intl.NumberFormat("de-DE").format(this.model.typeCount);
    }
  }
};
</script>
